import type { Filter } from '@/app/common/filters/core/filtersTypes';
import { filterTypeOf } from '@/app/common/filters/types/filterTypeBehaviour.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import type { Localization } from '@/app/components/search/common/Localization.ts';

export function getSelectedValueLabelForFilters(
  filters: Filter[],
  t?: TranslationFunction,
  localization?: Localization,
  selectionOrder?: string[]
): string {
  const { pillLabels, leadingLabel, extraCount } = filterTypeOf(filters[0]);
  let cached: string[] | undefined;
  const labelsOf = () => {
    cached ??= pillLabels(filters[0], t, localization);
    return cached;
  };

  const firstSelected = leadingLabel ? leadingLabel(filters, t, localization, selectionOrder) : labelsOf()[0];
  const totalSelected = extraCount ? extraCount(filters, t, localization) : labelsOf().length - 1;
  const counterLabel = totalSelected ? ` +${totalSelected}` : '';

  return `${firstSelected}${counterLabel}`;
}
